import http from './api'

const route = 'app/comercialicmsst/'

export default {
  showICMSST: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showICMSST', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showIcmsstAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showIcmsstAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showIcmsstAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showIcmsstAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showLeite: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showLeite', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showLeiteAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showLeiteAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },

  showLeiteAnoAnterior: (dataInicio, dataFim, select, supervisor, receita, tokenContrato) => {
    return http.post(route + 'showLeiteAnoAnterior', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
    })
  },
}
